import {keepPreviousData, useQuery} from "@tanstack/react-query";
import {getMultiAccounts, getRelatedAccounts} from "@containers/account/api/api";
import {IPropsGetRelatedAccounts} from "@containers/account/types";
import {useShowError} from "@hooks/useShowError/useShowError";
import {QUERY_KEY_MULTI_ACCOUNTS, QUERY_KEY_RELATED_ACCOUNTS} from './constants/queryKey'

export const useGetRelatedAccountsQuery = ({
                                               params,
                                               enabled
                                           }: {
    params: IPropsGetRelatedAccounts,
    enabled?: boolean
}) => {
    const {onShowError} = useShowError()

    return useQuery({
        queryFn: () => getRelatedAccounts(params, onShowError),
        queryKey: [QUERY_KEY_RELATED_ACCOUNTS, params.accountId?.toString(),params?.featureFlag],
        staleTime: 1000 * 60 * 30,
        enabled,
        placeholderData: keepPreviousData,
    });
}


export const useGetMultiAccountsQuery = ({

                                             enabled
                                         }: {
    enabled?: boolean
}={}) => {
    const {onShowError} = useShowError()

    return useQuery({
        queryFn: () => getMultiAccounts(onShowError),
        queryKey: [QUERY_KEY_MULTI_ACCOUNTS,],
        staleTime: 1000 * 60 * 30,
        enabled,
        placeholderData: keepPreviousData,
    });
}
